module.exports = __webpack_public_path__ + "img/logo.cb158537.png";